import type { ValueOptions } from "@mui/x-data-grid-pro";

type CountryOption = {
  value?: string | number;
  label?: string;
};

/** Resolve a stored country type ID (e.g. companies_country_default) to its type name. */
export function normalizeCountryLabel(
  value?: string | number | null,
  options: ReadonlyArray<ValueOptions | CountryOption> = []
): string {
  const raw = String(value ?? "").trim();
  if (!raw) return "";

  const byLabel = options.find(
    (option) =>
      String((option as CountryOption).label ?? "")
        .trim()
        .toLowerCase() === raw.toLowerCase()
  );
  if (byLabel && (byLabel as CountryOption).label != null) {
    return String((byLabel as CountryOption).label);
  }

  const byId = options.find(
    (option) => String((option as CountryOption).value ?? "").trim() === raw
  );
  if (byId && (byId as CountryOption).label != null) {
    return String((byId as CountryOption).label);
  }

  return raw;
}
